import {useEffect} from 'react';
import {useFormikContext} from 'formik';
import {jobDetailsSet} from 'components/customer/Confirmation/store/confirmationSlice';
import {JobForm} from 'components/customer/Job/entity/JobForm';
import {useAppDispatch} from 'store/customer';
import {useFreightContext} from 'components/customer/Confirmation/Freight';

// this "component" basically syncs formik and redux states
export const ReportJobDetails = (): null => {
    const dispatch = useAppDispatch();
    const {values} = useFormikContext<JobForm>();
    const {requestedDeliveryDate} = useFreightContext();

    useEffect(() => {
        dispatch(jobDetailsSet({...values, requestedDeliveryDate}));
    }, [values, requestedDeliveryDate]);

    return null;
};
